import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import {QUICK_FILTER_API_URL} from '../reimbusement/paymentIntegrity/apiUrlConstants';

const _httpService = new HttpService();

if(checkIsInternal()){
    _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}
else{
 _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
}
export const getTopFilterData = async (payload: any) => {
    try {
      const response: any = await _httpService.push(QUICK_FILTER_API_URL, payload);
      return response;
    } catch (error) {
      console.error('API call failed:', error);
      return null;
    }
   };